import { useRequestGetCertifications } from '@/hooks/httpRequest';
import { VerificationAdditionalCheckStatusEnum } from '@/enums';
import useUrlParams from './useUrlParams';

const useCertifications = () => {

  const { gender } = useUrlParams();
  const result = useRequestGetCertifications(
    {
      gender,
      additionalCheckStatus: VerificationAdditionalCheckStatusEnum.WITHOUT_STATE
    },
    !!gender
  );

  return result;

};

export default useCertifications;
